import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=3fa804b4&scoped=true&"
import script from "./wishlist.vue?vue&type=script&lang=js&"
export * from "./wishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa804b4",
  null
  
)

export default component.exports